<template>
  <div>
    <!-- 编辑表单组件 -->
    <div v-if="type === 'MakeForm' || type === 'ShowForm'">
      <item-box
        :data="data"
        :is-make-form="type === 'MakeForm'"
        :prop="prop"
        :show-mask="data.name !== 'Layout'"
        :style="{ padding: data.name === 'Layout' ? '0!important' : undefined }"
        @copy="$emit('copy', data)"
        @delete="$emit('delete', data)"
      >
        <slot :itemData="data" :itemModel="model" />
        <h-input
          v-if="data.name === 'Input'"
          :data="data"
          :model="model"
        />
        <h-textarea
          v-else-if="data.name === 'Textarea'"
          :data="data"
          :model="model"
        />
        <h-phone
          v-else-if="data.name === 'Phone'"
          :data="data"
          :model="model"
        />
        <h-password
          v-else-if="data.name === 'Password'"
          :data="data"
          :model="model"
        />

        <h-radio
          v-else-if="data.name === 'Radio'"
          :data="data"
          :model="model"
        />
        <h-checkbox
          v-else-if="data.name === 'Checkbox'"
          :data="data"
          :model="model"
        />
        <h-select
          v-else-if="data.name === 'Select'"
          :data="data"
          :model="model"
        />
        <h-time-picker
          v-else-if="data.name === 'TimePicker'"
          :data="data"
          :model="model"
        />
        <h-time-picker-multiple
          v-else-if="data.name === 'TimePickerMultiple'"
          :data="data"
          :model="model"
        />
        <h-date-picker
          v-else-if="data.name === 'DatePicker'"
          :data="data"
          :model="model"
        />
        <h-date-picker-multiple
          v-else-if="data.name === 'DatePickerMultiple'"
          :data="data"
          :model="model"
        />

        <h-rate
          v-else-if="data.name === 'Rate'"
          :data="data"
          :model="model"
        />
        <h-switch
          v-else-if="data.name === 'Switch'"
          :data="data"
          :model="model"
        />
        <h-input-number
          v-else-if="data.name === 'InputNumber'"
          :data="data"
          :model="model"
        />

        <h-link v-else-if="data.name === 'Link'" :data="data" />
        <h-divider
          v-else-if="data.name === 'Divider'"
          :data="data"
        />
        <h-layout
          v-else-if="data.name === 'Layout'"
          :data="data"
          :type="type"
          :model="model"
        >
          <div slot-scope="{layoutData, layoutModel}">
            <slot :itemData="layoutData" :itemModel="layoutModel" />
          </div>
        </h-layout>
      </item-box>
    </div>
    <!-- 编辑表单配置 -->
    <div v-if="type === 'SettingForm'">
      <slot name="setting" :itemData="data" :itemModel="model" />
      <h-input-setting
        v-if="data.name === 'Input'"
        :data="data"
      />
      <h-textarea-setting
        v-else-if="data.name === 'Textarea'"
        :data="data"
      />
      <h-phone-setting
        v-else-if="data.name === 'Phone'"
        :data="data"
      />
      <h-password-setting
        v-else-if="data.name === 'Password'"
        :data="data"
      />

      <h-radio-setting
        v-else-if="data.name === 'Radio'"
        :data="data"
      />
      <h-checkbox-setting
        v-else-if="data.name === 'Checkbox'"
        :data="data"
      />
      <h-select-setting
        v-else-if="data.name === 'Select'"
        :data="data"
      />
      <h-time-picker-setting
        v-else-if="data.name === 'TimePicker'"
        :data="data"
      />
      <h-time-picker-multiple-setting
        v-else-if="data.name === 'TimePickerMultiple'"
        :data="data"
      />
      <h-date-picker-setting
        v-else-if="data.name === 'DatePicker'"
        :data="data"
      />
      <h-date-picker-multiple-setting
        v-else-if="data.name === 'DatePickerMultiple'"
        :data="data"
      />

      <h-rate-setting
        v-else-if="data.name === 'Rate'"
        :data="data"
      />
      <h-switch-setting
        v-else-if="data.name === 'Switch'"
        :data="data"
      />
      <h-input-number-setting
        v-else-if="data.name === 'InputNumber'"
        :data="data"
      />

      <h-link-setting
        v-else-if="data.name === 'Link'"
        :data="data"
      />
      <h-divider-setting
        v-else-if="data.name === 'Divider'"
        :data="data"
      />
      <h-layout-setting
        v-else-if="data.name === 'Layout'"
        :data="data"
      />
    </div>
  </div>
</template>

<script>
import { Elements } from './index.js'
import ItemBox from '../common/ItemBox'
export default {
  name: 'WhichElement',
  components: { ...Elements, ItemBox },
  props: {
    custom: Boolean,
    data: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'MakeForm'
    },
    prop: {
      type: String,
      default: ''
    },
    model: {
      type: [Object, null],
      default: null
    }
  }
}
</script>
